import {getSaleHistoryDetailByApi} from '@web/actions/saleHistory'
import {decodeHtmlEntities} from '@web/helpers/htmlEntities'
import {getInitialState} from '@web/slices/deliveryInfo/slice'
import makeSlice from '@web/slices/deliveryInfo/sliceMaker'

const deliveryInfoSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getSaleHistoryDetailByApi.pending, () => {
                return getInitialState()
            })
            .addCase(getSaleHistoryDetailByApi.fulfilled, (state, {payload}) => {
                const {deliveryAddress, productOrders} = payload.detail

                if (
                    productOrders.some(({deliveryMethodType}) => {
                        return ['DELIVERY_DESIGNATED', 'CONVENIENCE_DELIVERY'].includes(deliveryMethodType)
                    })
                ) {
                    const isDeliveryDesignated = productOrders.some(({deliveryMethodType}) => {
                        return ['DELIVERY_DESIGNATED'].includes(deliveryMethodType)
                    })
                    state.disabledReason = isDeliveryDesignated ? 'DELIVERY_DESIGNATED' : 'CONVENIENCE_DELIVERY'
                } else if (deliveryAddress) {
                    const {
                        receiverName = '',
                        receiverTelNo1 = '',
                        receiverTelNo2 = '',
                        virtualPhoneNumber = '',
                        zipCode = '',
                        baseAddress = '',
                        detailAddress = '',
                        deliveryMemoParticularInput,
                        deliveryMemos = [],
                    } = deliveryAddress
                    // 안심번호
                    state.virtualPhoneNumber = {
                        used: !!virtualPhoneNumber,
                        onVirtualPhoneNumber: !!virtualPhoneNumber,
                        value: virtualPhoneNumber,
                    }

                    // 배송메모
                    state.memo.particularInputByItemId = deliveryMemos.reduce<
                        Record<
                            number,
                            {
                                value: string
                                options: string
                                originProductName: string
                            }
                        >
                    >((acc, {productName, deliveryMemo, optionContents}, idx) => {
                        return {
                            ...acc,
                            [idx]: {
                                value: decodeHtmlEntities(deliveryMemo) ?? '',
                                options: optionContents ?? '',
                                originProductName: productName,
                            },
                        }
                    }, {})
                    state.memo.isParticularInput = !!deliveryMemoParticularInput

                    // 배송지
                    state.selected.addressInfo = {
                        hash: '',
                        addressName: '',
                        receiverName: decodeHtmlEntities(receiverName),
                        zipCode,
                        baseAddress: decodeHtmlEntities(baseAddress),
                        detailAddress: decodeHtmlEntities(detailAddress),
                        telNo1: receiverTelNo1,
                        telNo2: receiverTelNo2,
                        isPrimaryAddress: true,
                        isRegistered: true,
                        isRoadNameAddress: false,
                        buildingManagementNo: null,
                        locationX: null,
                        locationY: null,
                    }
                    state.selected.recipient = 'NORMAL'

                    // 배송지 변경 가능 여부
                    state.isDeliveryChangeable = false
                }
            })
    },
})

export default deliveryInfoSlice.reducer
